import { useMutationEndpoint, UseMutationOptionsFromProvider } from '../../core'
import { postAuthTokenRefresh } from '../endpoints'

type MutationParams = Parameters<typeof postAuthTokenRefresh>[0]

export const usePostTokenRefresh = (
  options?: UseMutationOptionsFromProvider<
    typeof postAuthTokenRefresh,
    MutationParams
  >,
) =>
  useMutationEndpoint(
    (data: MutationParams) => postAuthTokenRefresh(data),
    options,
  )
